import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HOTEL_ONLY } from 'constants/selectValues';
import PromotionsComponent from './PromotionsComponent';

class Promotions extends Component {
  render() {
    const { origin, co2Compensation, airlineWhitelabel, ...props } = this.props;
    const _co2Compensation = origin && origin !== HOTEL_ONLY && co2Compensation;

    if (!props.showPromotions) {
      return null;
    }

    return <PromotionsComponent co2Compensation={_co2Compensation} airlineWhitelabel={airlineWhitelabel} {...props} />;
  }
}

function mapStateToProps(state) {
  const origin = state.hotelPagePackageInfo.current && state.hotelPagePackageInfo.current.search.origin;

  return {
    origin,
    co2Compensation: state.settings.value.co2Compensation,
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
  };
}

export default connect(mapStateToProps)(Promotions);
